import "./Home.css"
import { BiHome } from "@react-icons/all-files/bi/BiHome";
import { HiArrowDown } from "@react-icons/all-files/hi/HiArrowDown";
import { Link } from "react-scroll";
import AOS from "aos"
import "aos/dist/aos.css";

const Home = () => {
  const { innerWidth: width} = window;
  AOS.init();
    return (
      <div className="pages-page-main">
        <div className="pages-inner-content">
          {width > 1270 ? (
            <div
              data-aos="fade-left"
              data-aos-offset="50"
              data-aos-delay="2000"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
              className="pages-heading-div"
            >
              <BiHome className="pages-page-icon" />
              <span className="pages-introduce">introduce</span>
            </div>
          ) : (
            <div
              data-aos="fade-left"
              data-aos-offset="0"
              data-aos-delay="0"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
              className="pages-heading-div"
            >
              <BiHome className="pages-page-icon" />
              <span className="pages-introduce">introduce</span>
            </div>
          )}
          <div className="pages-introduction-heading">
            {width > 1270 ? (
              <div
                data-aos="fade-right"
                data-aos-offset="0"
                data-aos-delay="2000"
                data-aos-duration="1000"
              >
                say Hi from <span className="colored-heading">suryansh</span>,
              </div>
            ) : (
              <div
                data-aos="fade-right"
                data-aos-offset="0"
                data-aos-delay="0"
                data-aos-duration="1000"
              >
                say Hi from <span className="colored-heading">suryansh</span>,
              </div>
            )}
            {width > 1270 ? (
              <div
                data-aos="fade-left"
                data-aos-offset="50"
                data-aos-delay="2000"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
              >
                {" "}
                full-Stack react &
              </div>
            ) : (
              <div
                data-aos="fade-left"
                data-aos-offset="50"
                data-aos-delay="0"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
              >
                {" "}
                full-Stack react &
              </div>
            )}
            {width > 1270 ? (
              <div
                data-aos="fade-up"
                data-aos-offset="0"
                data-aos-delay="2000"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
              >
                react-native
              </div>
            ) : (
              <div
                data-aos="fade-up"
                data-aos-offset="0"
                data-aos-delay="0"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
              >
                react-native
              </div>
            )}
            {width > 1270 ? (
              <div
                data-aos="fade-up"
                data-aos-offset="0"
                data-aos-delay="2000"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
              >
                developer
              </div>
            ) : (
              <div
                data-aos="fade-up"
                data-aos-offset="0"
                data-aos-delay="0"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
              >
                developer
              </div>
            )}
          </div>
          {width > 1270 ? (
            <div
              data-aos="fade-up"
              data-aos-offset="50"
              data-aos-delay="2000"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
              className="pages-description"
            >
              I design and code beautifully simple things and i love what i do.
              Just simple like that!
            </div>
          ) : (
            <div
              data-aos="fade-up"
              data-aos-offset="50"
              data-aos-delay="0"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
              className="pages-description"
            >
              I design and code beautifully simple things and i love what i do.
              Just simple like that!
            </div>
          )}
          {width>1270?<div className="project-arrow-main-div">
            <Link
              to="projects"
              smooth={true}
              className="project-arrow-div"
              data-aos="fade-up"
              data-aos-offset="50"
              data-aos-delay="2700"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
            >
              <img
                className="project-name-arrow-image"
                src="https://wordpressriverthemes.com/drake/wp-content/uploads/2023/03/round-text.png"
                alt="img"
              ></img>
              <HiArrowDown className="down-arrow" />
            </Link>
          </div>:
          <div className="project-arrow-main-div">
            <Link
              to="projects"
              smooth={true}
              className="project-arrow-div"
              data-aos="fade-up"
              data-aos-offset="50"
              data-aos-delay="0"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
            >
              <img
                className="project-name-arrow-image"
                src="https://wordpressriverthemes.com/drake/wp-content/uploads/2023/03/round-text.png"
                alt="img"
              ></img>
              <HiArrowDown className="down-arrow" />
            </Link>
          </div>}
        </div>
      </div>
    );
}
export default Home
